function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 32,
  fill: "#A6C6FF",
  fillOpacity: 0.27
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 24.755,
  r: 6.642,
  fill: "#005DFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.45,
  d: "M44.68 44.075a12.68 12.68 0 00-25.36 0h25.36z",
  fill: "#005DFF"
});

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgcng9IjMyIiBmaWxsPSIjQTZDNkZGIiBmaWxsLW9wYWNpdHk9IjAuMjciLz4KPGNpcmNsZSBjeD0iMzIiIGN5PSIyNC43NTQ4IiByPSI2LjY0MTUxIiBmaWxsPSIjMDA1REZGIi8+CjxwYXRoIG9wYWNpdHk9IjAuNDUiIGQ9Ik00NC42NzkzIDQ0LjA3NTJDNDQuNjc5MyA0MC43MTI1IDQzLjM0MzQgMzcuNDg3NSA0MC45NjU2IDM1LjEwOTdDMzguNTg3OCAzMi43MzE4IDM1LjM2MjggMzEuMzk2IDMyIDMxLjM5NkMyOC42MzczIDMxLjM5NiAyNS40MTIzIDMyLjczMTggMjMuMDM0NSAzNS4xMDk3QzIwLjY1NjYgMzcuNDg3NSAxOS4zMjA4IDQwLjcxMjUgMTkuMzIwOCA0NC4wNzUyTDMyIDQ0LjA3NTJMNDQuNjc5MyA0NC4wNzUyWiIgZmlsbD0iIzAwNURGRiIvPgo8L3N2Zz4K";
export { SvgUser as ReactComponent };